import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetQuestionListFailed, EGetQuestionListActionType } from './types';

export const getQuestionListFailed: () => TGetQuestionListFailed = actionGenerator<EGetQuestionListActionType.Failed>(
  EGetQuestionListActionType.Failed,
);
